export const PLANET_HD_JOB_STATES = {
  QUEUED: 'queued',
  PROCESSING: 'processing',
  PAUSED_PROVIDER_CAPACITY: 'paused_provider_capacity',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
}

const STATUS_ALIASES = {
  '0': PLANET_HD_JOB_STATES.PROCESSING,
  '1': PLANET_HD_JOB_STATES.COMPLETED,
  queued: PLANET_HD_JOB_STATES.QUEUED,
  pending: PLANET_HD_JOB_STATES.QUEUED,
  preparing: PLANET_HD_JOB_STATES.PROCESSING,
  processing: PLANET_HD_JOB_STATES.PROCESSING,
  running: PLANET_HD_JOB_STATES.PROCESSING,
  paused: PLANET_HD_JOB_STATES.PAUSED_PROVIDER_CAPACITY,
  paused_provider_capacity: PLANET_HD_JOB_STATES.PAUSED_PROVIDER_CAPACITY,
  suspended_pu: PLANET_HD_JOB_STATES.PAUSED_PROVIDER_CAPACITY,
  ready: PLANET_HD_JOB_STATES.COMPLETED,
  completed: PLANET_HD_JOB_STATES.COMPLETED,
  succeeded: PLANET_HD_JOB_STATES.COMPLETED,
  error: PLANET_HD_JOB_STATES.FAILED,
  failed: PLANET_HD_JOB_STATES.FAILED,
  cancelled: PLANET_HD_JOB_STATES.CANCELLED,
  canceled: PLANET_HD_JOB_STATES.CANCELLED,
  deleted: PLANET_HD_JOB_STATES.CANCELLED,
  retired: PLANET_HD_JOB_STATES.CANCELLED,
}

export const normalizePlanetHdJobStatus = (status) => (
  STATUS_ALIASES[String(status ?? '').trim().toLowerCase()] || null
)

export const isPlanetHdJobPending = (status) => [
  PLANET_HD_JOB_STATES.QUEUED,
  PLANET_HD_JOB_STATES.PROCESSING,
  PLANET_HD_JOB_STATES.PAUSED_PROVIDER_CAPACITY,
].includes(normalizePlanetHdJobStatus(status))

export const isPlanetHdJobReady = (status) => (
  normalizePlanetHdJobStatus(status) === PLANET_HD_JOB_STATES.COMPLETED
)

export const isPlanetHdJobFailed = (status) => (
  normalizePlanetHdJobStatus(status) === PLANET_HD_JOB_STATES.FAILED
)
